export default class Event {
}
Event.endpoint = '/v1/events';
